import { render, staticRenderFns } from "./Sample.vue?vue&type=template&id=ffc7d1f4&scoped=true&"
import script from "./Sample.vue?vue&type=script&lang=js&"
export * from "./Sample.vue?vue&type=script&lang=js&"
import style0 from "./Sample.vue?vue&type=style&index=0&id=ffc7d1f4&prod&scoped=true&lang=scss&"
import style1 from "./Sample.vue?vue&type=style&index=1&id=ffc7d1f4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffc7d1f4",
  null
  
)

export default component.exports